import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import {
  type PathLayoutButtons,
  loadPathLayoutButtons,
} from 'components/Graph/resources/pathLayoutButtons';
import { Loader } from 'pixi.js';
import { promiseOnce } from 'utils/promiseOnce';
import { loadFonts } from './fonts';

interface GraphResources {
  pathLayoutButtons: PathLayoutButtons;
}

let resources: GraphResources | null = null;

export function getGraphResources(): GraphResources {
  if (resources === null) {
    throw new IpfError(
      'INVALID_STATE',
      'Call await loadGraphResources() before using graph resources',
    );
  }
  return resources;
}

export const loadGraphResources = promiseOnce(async () => {
  const loader = new Loader();

  loadFonts(loader);

  const [pathLayoutButtons] = await Promise.all([
    // We load node textures aside of PIXI.Loader, because it caused this bug:
    // https://ipfabric.atlassian.net/browse/NIM-4214
    // The reason is that PIXI loader accepts svg only as a data URL,
    // we use the same data URL to display node icons in <img> tags
    // and it seems that Chrome and Safari screw up texture dimensions in internal cache
    // somehow. The only way I found to avoid this is to load these textures
    // via PIXI.Texture.from(svg), which accepts a plain SVG string (not a data URL).
    loadPathLayoutButtons(),
    new Promise<void>((resolve) => {
      loader.load(() => {
        resolve();
      });
    }),
  ]);
  resources = { pathLayoutButtons };
});
